import { FC } from 'react';
import { Moment } from 'moment';
import { useProfileInsightsQuery } from '../hooks';
import { useAngularListSegmentContext } from '../../contexts/AngularListSegmentContext';
import { useInsightsQueryContext } from './InsightsQueryContext';
import { ProfileQueryState, ProfileQueryContext } from './ProfileQueryContext';

export const ProfileQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { listDetails } = useAngularListSegmentContext();
  const { startDate, endDate } = useInsightsQueryContext();

  const insightQueryParam = listDetails
    ? {
        ...listDetails,
        startDate: (startDate as Moment | null)?.toISOString(),
        endDate: (endDate as Moment | null)?.toISOString(),
      }
    : undefined;

  const {
    data: profile,
    error: profileError,
    isError: isProfileError,
    isLoading: isProfileLoading,
    refetch: refetchProfile,
  } = useProfileInsightsQuery(insightQueryParam);

  const context: ProfileQueryState = {
    isProfileError,
    profileError,
    isProfileLoading,
    refetchProfile,
    profile,
    ...profile,
  };

  return <ProfileQueryContext.Provider value={context}>{children}</ProfileQueryContext.Provider>;
};
